<template>
  <div id="rare-list-page" class="rfp-rr-ratings-list">
    <div class="rfp-comon-space-declaration"></div>
    <div class="rfp-rr-most-ratings-list-050-or rfp-rr-header">
      <p
        v-if="hasData && ratingsListOption != CAROUSEL_VIEW"
        role="status"
        class="rfp-rr-most-ratings-list-051-or rfp-header-menu"
      >
        <span class="rfp-rr-most-ratings-list-0520-or">{{ resultsCountText }}</span>
      </p>
      <p v-else role="status" class="rfp-rr-most-ratings-list-051-or rfp-header-menu">
        <span class="rfp-rr-most-ratings-list-0520-or">
          {{ paginationShowing }}
          {{ totalNoOfApprovedReviews > 0 ? currentPaginationPage + 1 : 0 }} {{ paginationOutof }}
          {{ totalNoOfApprovedReviews }}
        </span>
      </p>
      <div class="rfp-rr-header-right">
        <span
          v-if="ratingsListOption != CAROUSEL_VIEW"
          ref="sortLabel"
          role="button"
          tabindex="0"
          class="rfp-rr-most-ratings-list-061-or"
          :aria-expanded="String(isSortDropdownOpen)"
          :aria-label="sortFilterAccessibleLabel.replace('{{value}}', selectedSortLabel)"
          @blur="handleSortBlur"
          @keydown.esc="closeSortOptions"
          @keydown.space.prevent
          @keyup.space="toggleSortDropdown"
          @keydown.enter="toggleSortDropdown"
          @click="toggleSortDropdown"
        >
          <div class="rfp-rr-most-ratings-list-062-or">
            <p class="rfp-rr-most-ratings-list-063-or">
              {{ selectedSortLabel }}<i aria-hidden="true" class="arrow-down"></i>
            </p>
          </div>
        </span>
        <ul
          v-if="isSortDropdownOpen"
          ref="sortOptionsList"
          class="rfp-rr-most-ratings-list-066-or rr-sort-content rating-sort rfp-sort-arrow_box"
          :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
          @keydown.esc="closeSortOptions"
        >
          <li
            v-for="(x, listIndex) in sortList"
            :key="listIndex"
            class="rfp-rr-most-ratings-list-067-or black bold"
            @mousedown.left="sortReviews(x.Key)"
          >
            <div
              role="button"
              tabindex="0"
              :aria-current="selectedSortValue === x.Key"
              class="rfp-rr-most-ratings-list-item-button"
              @keydown.enter="sortReviews(x.Key)"
              @keydown.space.prevent="sortReviews(x.Key)"
              @blur="handleSortBlur"
            >
              <span class="rfp-rr-most-ratings-list-item-button__option-label">{{ x.Value }}</span>

              <div
                v-if="selectedSortValue === x.Key"
                class="rfp-rr-most-ratings-list-item-button__option-check-icon"
              >
                <check-icon />
              </div>
            </div>
          </li>
        </ul>
        <span class="rfp-common-space"></span>
      </div>
    </div>
    <div>
      <div class="rfp-comon-space-declaration"></div>
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <symbol id="rfp-ratings-checkmark" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-miterlimit="10"
            fill="none"
            d="M22.9 3.7l-15.2 16.6-6.6-7.1"
          ></path>
        </symbol>
      </svg>
      <div class="form-container">
        <div
          id="rfp-rr-ratings-filter-by-rating-label"
          class="rfp-rr-ratings-filter-by-rating-label"
        >
          {{ filterByRatingLabel }}
        </div>
        <div
          role="radiogroup"
          aria-labelledby="rfp-rr-ratings-filter-by-rating-label"
          class="rfp-rr-ratings-display-contents"
        >
          <ul class="rfp-rr-ratings-display-contents">
            <li class="rfp-rr-ratings-display-contents">
              <div
                class="rfp-ratings-promoted-checkbox"
                :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
                @click="filterByStars('one')"
              >
                <input
                  id="rfp-rr-ratings-star-filters-one"
                  v-model="rfpFilterOne"
                  type="checkbox"
                  class="rfp-ratings-promoted-input-checkbox"
                />
                <label for="rfp-rr-ratings-star-filters-one" @click.prevent>
                  <svg
                    aria-hidden="true"
                    :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }"
                  >
                    <use xlink:href="#rfp-ratings-checkmark" />
                  </svg>
                  {{ oneStarText }}
                </label>
              </div>
            </li>
            <li class="rfp-rr-ratings-display-contents">
              <div
                class="rfp-ratings-promoted-checkbox"
                :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
                @click="filterByStars('two')"
              >
                <input
                  id="rfp-rr-ratings-star-filters-two"
                  v-model="rfpFilterTwo"
                  type="checkbox"
                  class="rfp-ratings-promoted-input-checkbox"
                />
                <label for="rfp-rr-ratings-star-filters-two" @click.prevent>
                  <svg
                    aria-hidden="true"
                    :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }"
                  >
                    <use xlink:href="#rfp-ratings-checkmark" />
                  </svg>
                  {{ twoStarText }}
                </label>
              </div>
            </li>
            <li class="rfp-rr-ratings-display-contents">
              <div
                class="rfp-ratings-promoted-checkbox"
                :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
                @click="filterByStars('three')"
              >
                <input
                  id="rfp-rr-ratings-star-filters-three"
                  v-model="rfpFilterThree"
                  type="checkbox"
                  class="rfp-ratings-promoted-input-checkbox"
                />
                <label for="rfp-rr-ratings-star-filters-three" @click.prevent>
                  <svg
                    aria-hidden="true"
                    :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }"
                  >
                    <use xlink:href="#rfp-ratings-checkmark" />
                  </svg>
                  {{ threeStarText }}
                </label>
              </div>
            </li>
            <li class="rfp-rr-ratings-display-contents">
              <div
                class="rfp-ratings-promoted-checkbox"
                :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
                @click="filterByStars('four')"
              >
                <input
                  id="rfp-rr-ratings-star-filters-four"
                  v-model="rfpFilterFour"
                  type="checkbox"
                  class="rfp-ratings-promoted-input-checkbox"
                />
                <label for="rfp-rr-ratings-star-filters-four" @click.prevent>
                  <svg
                    aria-hidden="true"
                    :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }"
                  >
                    <use xlink:href="#rfp-ratings-checkmark" />
                  </svg>
                  {{ fourStarText }}
                </label>
              </div>
            </li>
            <li class="rfp-rr-ratings-display-contents">
              <div
                class="rfp-ratings-promoted-checkbox"
                :class="{ 'rfp-rr-rating-rtl-rating-list-box': isRightToLeftActive }"
                @click="filterByStars('five')"
              >
                <input
                  id="rfp-rr-ratings-star-filters-five"
                  v-model="rfpFilterFive"
                  type="checkbox"
                  class="rfp-ratings-promoted-input-checkbox"
                />
                <label for="rfp-rr-ratings-star-filters-five" @click.prevent>
                  <svg
                    aria-hidden="true"
                    :class="{ 'rfp-rr-rating-rtl-rating-list-filter': isRightToLeftActive }"
                  >
                    <use xlink:href="#rfp-ratings-checkmark" />
                  </svg>
                  {{ fiveStarText }}
                </label>
              </div>
            </li>
          </ul>
        </div>

        <span
          role="button"
          tabindex="0"
          class="rfp-ratings-clearAll_filter"
          :class="{ 'rfp-ratings-clearAll_filter--visible': isClearAllFiltersButtonVisible }"
          @keydown.space.prevent
          @keyup.space="clearAllStars"
          @keydown.enter="clearAllStars"
          @click="clearAllStars"
        >
          {{ clearAll }}
        </span>
      </div>
    </div>
    <div class="rfp-comon-space-declaration"></div>
    <div
      id="rfp-rr-ratings-reviews-results-list"
      class="rfp-rr-most-ratings-list-095-or rr-all-review-container"
      tabindex="-1"
    >
      <slot v-if="isDefaultSlotRendered" />
      <template v-else-if="itemsWithNickname.length == 0">
        <div
          v-if="!loadingItems"
          class="rfp-rr-most-ratings-list-129-or no_record__found"
          v-text="noRecordFound"
        ></div>
      </template>

      <template v-else-if="ratingsListOption === CAROUSEL_VIEW">
        <rfp-ratings-carousel
          v-slot="{ currentPage }"
          ref="carousel"
          :autoplay="false"
          :autoplay-timeout="10000"
          :loop="false"
          :autoplay-hover-pause="true"
          :min-swipe-distance="8"
          pagination-active-color="#f30606"
          pagination-color="#efefef"
          :pagination-padding="10"
          :pagination-size="10"
          :per-page="1"
          :review-count="totalNoOfApprovedReviews"
          :navigation-enabled="true"
          :pagination-enabled="false"
          :reset-results-api-request-count="resetResultsApiRequestCount"
        >
          <rfp-ratings-slide v-for="(item, index) in itemsWithNickname" :key="item.RRID">
            <rfp-ratings-list-item
              :review="item"
              :inert="index !== currentPage"
              @modal-open="openModal"
              @report-review="reportReview"
              @vote-review="voteReview"
            ></rfp-ratings-list-item>
          </rfp-ratings-slide>
        </rfp-ratings-carousel>
      </template>
      <div v-else-if="ratingsListOption === LOAD_MORE" role="list">
        <rfp-ratings-list-item
          v-for="item in itemsWithNickname"
          :key="item.RRID"
          :review="item"
          role="listitem"
          @modal-open="openModal"
          @report-review="reportReview"
          @vote-review="voteReview"
        ></rfp-ratings-list-item>
        <button
          v-if="numberOfReviews < totalNoOfApprovedReviews"
          class="rfp-ratings-load-more"
          @click="loadMoreReviews"
        >
          <span v-text="showMoreText"></span>
        </button>
      </div>
      <template v-else>
        <refapp-paginate
          ref="paginator"
          name="items"
          :list="items"
          :per="reviewPaginationCount"
          class="rfp-rr-most-ratings-list-096-or paginate-list"
        >
          <rfp-ratings-list-item
            v-for="item in paginated('items')"
            :key="item.RRID"
            :review="item"
            role="listitem"
            tabindex="-1"
            class="js-rfp-rr-ratings-list-item"
            @modal-open="openModal"
            @report-review="reportReview"
            @vote-review="voteReview"
          ></rfp-ratings-list-item>
        </refapp-paginate>
        <div class="rfp-rr-most-ratings-list-130-or rr-table-footer">
          <span class="rfp-rr-most-ratings-list-0520-or" v-text="resultsCountText"></span>
          <div class="rfp-rr-most-ratings-list-132-or rr-table-footer-right float-right">
            <div id="navcontainer">
              <rfp-ratings-pagination-links
                ref="paginationLinks"
                :page-count="totalNumberOfPages"
                :prev-text="paginationPrevious"
                :next-text="paginationNext"
                @input="updatePage"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div>
      <rfp-ratings-list-carousel-modal
        :images="carouselConfig.modalImages"
        :main-position="carouselConfig.mainPosition"
        :visible="carouselConfig.showModal"
        :show-thumbnails="carouselConfig.showThumbnails"
        :modal-close-button-accessible-label="modalCloseButtonAccessibleLabel"
        :image-viewer-accessible-label="imageViewerAccessibleLabel"
        @closedmodal="closeModal"
      >
      </rfp-ratings-list-carousel-modal>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpRatingsListCarouselModal from './rfp-ratings-list-carousel-modal/rfp-ratings-list-carousel-modal.vue';
import RfpRatingsCarousel from '../../rfp-ratings-slider/rfp-ratings-carousel.vue';
import RfpRatingsSlide from '../../rfp-ratings-slider/rfp-ratings-slide.vue';
import RfpRatingsPaginationLinks from '../../rfp-ratings-pagination-links/rfp-ratings-pagination-links.vue';
import RfpRatingsListItem from './rfp-ratings-list-item/rfp-ratings-list-item.vue';
import CheckIcon from '../../../../../../shared/components/icons/check-icon.vue';

const LOAD_MORE = 'Ratings load more';
const CAROUSEL_VIEW = 'carousel list view';
const FILTER_ACTION_TRIGGERED_EVENT = 'filter-action-triggered';

export default {
  name: 'rfp-ratings-list',
  components: {
    CheckIcon,
    RfpRatingsSlide,
    RfpRatingsCarousel,
    RfpRatingsListCarouselModal,
    RfpRatingsListItem,
    RfpRatingsPaginationLinks,
  },
  provide() {
    return {
      ageLabel: this.ageLabel,
      currentPageUrl: window.location.href,
      facebookCaption: this.facebookCaption,
      facebookIcon: this.facebookIcon,
      facebookIconAlt: this.facebookIconAlt,
      facebookShareEnabled: this.facebookShareEnabled,
      fields: this.fields,
      helpfullIcon: this.helpfullIcon,
      helpfullIconAltText: this.helpfullIconAltText,
      helpfulLabel: this.helpfulLabel,
      isRightToLeftActive: this.isRightToLeftActive,
      isProductFreeDisplayText: this.isProductFreeDisplayText,
      nonHelpfullIcon: this.nonHelpfullIcon,
      nonHelpfullIconAltText: this.nonHelpfullIconAltText,
      notRecommendListIcon: this.notRecommendListIcon,
      notRecommendIconAltText: this.notRecommendIconAltText,
      qualityOfProductLabel: this.qualityOfProductLabel,
      shareDisplayConfig: this.shareDisplayConfig,
      showCreatedAt: this.showCreatedAt,
      showCriticalReviewSection: this.showCriticalReviewSection,
      showFavorableReviewSection: this.showFavorableReviewSection,
      showFreeProduct: this.showFreeProduct,
      showHideAgeRange: this.showHideAgeRange,
      showHideLocation: this.showHideLocation,
      showHideQualityRating: this.showHideQualityRating,
      showHideReviewContent: this.showHideReviewContent,
      showHideReviewTitle: this.showHideReviewTitle,
      showHideUserType: this.userTypeShowHide,
      showHideIsProductRecommended: this.showHideIsProductRecommended,
      showLabelNickname: this.showLabelNickname,
      starRatingIncrementValue: this.starRatingIncrementValue,
      starRatingMaxRatingValue: this.starRatingMaxRatingValue,
      starRatingInactiveColor: this.starRatingInactiveColor,
      starRatingActiveColor: this.starRatingActiveColor,
      starRatingStarSize: this.starRatingStarSize,
      starRatingAccessibleLabel: this.starRatingAccessibleLabel,
      recommendListIcon: this.recommendListIcon,
      recommendIconAltText: this.recommendIconAltText,
      reportText: this.reportText,
      reportedText: this.reportedText,
      userTypeDesc: this.userTypeDesc,
      viewUserUploadedImageAccessibleLabel: this.viewUserUploadedImageAccessibleLabel,
      userUploadedImageAccessibleLabel: this.userUploadedImageAccessibleLabel,
      paginationOutOfText: this.paginationOutof,
      previousText: this.paginationPrevious,
      nextText: this.paginationNext,
      voteHelpfulAccessibleLabel: this.voteHelpfulAccessibleLabel,
      voteNotHelpfulAccessibleLabel: this.voteNotHelpfulAccessibleLabel,
    };
  },
  props: {
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    sortList: {
      type: Array,
      required: true,
    },
    initialSortValue: {
      type: String,
      required: true,
    },
    oneStarText: {
      type: String,
      required: true,
    },
    twoStarText: {
      type: String,
      required: true,
    },
    threeStarText: {
      type: String,
      required: true,
    },
    fourStarText: {
      type: String,
      required: true,
    },
    fiveStarText: {
      type: String,
      required: true,
    },
    activeFilters: {
      type: String,
      required: true,
    },
    clearAll: {
      type: String,
      required: true,
    },
    qualityOfProductLabel: {
      type: String,
      required: true,
    },
    ageLabel: {
      type: String,
      required: true,
    },
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: true,
    },
    reported: {
      type: String,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    baseUrlsFetchReviewDetails: {
      type: String,
      required: true,
    },
    reviewPaginationCount: {
      type: Number,
      required: true,
    },
    reviewPaginataionText: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReview: {
      type: String,
      required: true,
    },
    noRecordFound: {
      type: String,
      required: true,
    },
    helpfullIcon: {
      type: String,
      required: true,
    },
    nonHelpfullIcon: {
      type: String,
      required: true,
    },
    helpfullIconAltText: {
      type: String,
      required: true,
    },
    nonHelpfullIconAltText: {
      type: String,
      required: true,
    },
    recommendIconAltText: {
      type: String,
      required: true,
    },
    recommendListIcon: {
      type: String,
      required: true,
    },
    notRecommendIconAltText: {
      type: String,
      required: true,
    },
    notRecommendListIcon: {
      type: String,
      required: true,
    },
    userTypeShowHide: {
      type: Boolean,
      required: true,
    },
    userTypeDesc: {
      type: String,
      required: true,
    },
    paginationShowing: {
      type: String,
      required: true,
    },
    paginationOutof: {
      type: String,
      required: true,
    },
    addIcon: {
      type: String,
      required: true,
    },
    filterEnable: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    ratingsListOption: {
      type: String,
      default: '',
    },
    showMoreText: {
      type: String,
      default: 'Show More',
    },
    paginationNext: {
      default: 'Next',
      type: String,
      required: false,
    },
    paginationPrevious: {
      default: 'Previous',
      type: String,
      required: false,
    },
    facebookCaption: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showHideLocation: {
      type: Boolean,
      default: true,
    },
    showHideAgeRange: {
      type: Boolean,
      default: true,
    },
    showHideReviewTitle: {
      type: Boolean,
      default: true,
    },
    showCreatedAt: {
      type: Boolean,
      default: true,
    },
    showHideReviewContent: {
      type: Boolean,
      default: true,
    },
    showHideQualityRating: {
      type: Boolean,
      default: true,
    },
    showHideIsProductRecommended: {
      type: Boolean,
      default: true,
    },
    showLabelNickname: {
      type: Boolean,
      default: false,
    },
    showFavorableReviewSection: {
      type: Boolean,
      default: true,
    },
    showCriticalReviewSection: {
      type: Boolean,
      default: true,
    },
    isProductFreeDisplayText: {
      type: String,
      required: false,
    },
    showFreeProduct: {
      type: String,
      required: false,
    },
    loadFromMultipleLanguages: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      required: true,
    },
    starRatingAccessibleLabel: {
      type: String,
      default: undefined,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: 'Close',
    },
    filterByRatingLabel: {
      type: String,
      default: 'Filter by rating',
    },
    sortFilterAccessibleLabel: {
      type: String,
      default: 'Sort the results, {{value}} selected',
    },
    imageViewerAccessibleLabel: {
      type: String,
      default: 'Image viewer',
    },
    viewUserUploadedImageAccessibleLabel: {
      type: String,
      default: 'View user uploaded image',
    },
    userUploadedImageAccessibleLabel: {
      type: String,
      default: 'User uploaded image',
    },
    voteHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Helpful. {{voteCount}} people found this review helpful',
    },
    voteNotHelpfulAccessibleLabel: {
      type: String,
      default: 'Vote Not helpful. {{voteCount}} people found this review not helpful',
    },
    totalReviewsCount: {
      type: Number,
      default: 0,
    },
    defaultReviewsJson: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDefaultSlotRendered: true,
      loadingItems: false,
      items: [],
      resetResultsApiRequestCount: 0,
      paginate: ['items'],
      carouselConfig: {
        modalImages: [],
        mainPosition: 0,
        showModal: false,
        showThumbnails: false,
      },
      stars: {
        oneStar: false,
        twoStar: false,
        threeStar: false,
        fourStar: false,
        fiveStar: false,
      },
      selectedSortValue: this.initialSortValue,
      upHere: false,
      helpfulLabels: this.helpfulLabel,
      reports: this.report,
      reporteds: this.reported,
      reportDisplayed: false,
      noDataFound: false,
      isSortDropdownOpen: false,
      currentPaginationPage: 0,
      rfpFilterOne: false,
      rfpFilterTwo: false,
      rfpFilterThree: false,
      rfpFilterFour: false,
      rfpFilterFive: false,
      currentPageNo: 1,
      totalNoOfApprovedReviews: this.totalReviewsCount,
      normalPagination: [],
      itemsByPage: {},
      maxPageLength: 1,
      currentPageUrl: window.location.href,
      CAROUSEL_VIEW,
      LOAD_MORE,
    };
  },
  computed: {
    numberOfReviews() {
      if (this.ratingsListOption === LOAD_MORE) return this.items.length;

      const currentPageTotal = this.currentPageNo * this.reviewPaginationCount;
      const fromCount = currentPageTotal - this.reviewPaginationCount + 1;
      const toCount =
        currentPageTotal > this.totalNoOfApprovedReviews
          ? this.totalNoOfApprovedReviews
          : currentPageTotal;
      return `${fromCount}-${toCount}`;
    },
    resultsCountText() {
      return `${this.paginationShowing} ${this.numberOfReviews} ${this.paginationOutof} ${this.totalNoOfApprovedReviews}`;
    },
    allItems() {
      const itemsByPageValues = Object.values(this.itemsByPage);
      return itemsByPageValues.length > 0 ? itemsByPageValues.flat() : this.items;
    },
    itemsWithNickname() {
      return this.items.filter((review) => review.NickName != '');
    },
    isClearAllFiltersButtonVisible() {
      return Object.values(this.stars).some(Boolean);
    },
    selectedSortLabel() {
      return this.sortList.find((item) => item.Key === this.selectedSortValue)?.Value;
    },
    totalNumberOfPages() {
      const reviewsPagination = Math.ceil(
        this.totalNoOfApprovedReviews / this.reviewPaginationCount,
      );
      return Math.max(reviewsPagination, 1);
    },
    hasData() {
      return this.itemsWithNickname.length > 0;
    },
  },
  created() {
    this.initDefaultReviews();
    this.setReadReviewTaggingEventWatcher();

    eventBus.on('rfpSetReportedStatus', ({ reviewId, isReported }) => {
      const review = this.allItems.find((review) => review.RRID === reviewId);
      if (review) {
        review.IsReported = isReported ? this.reportedText : this.reportText;
      }
    });

    eventBus.on(
      'rfpUpdateReviewVote',
      ({
        reviewId,
        isHelpful,
        /** to rollback optimistic update */
        rollbackUpdate = false,
      }) => {
        const review = this.allItems.find((review) => review.RRID === reviewId);
        if (!review) return;
        const updateVoteKey = isHelpful ? 'HelpfulCount' : 'NotHelpfulCount';

        if (rollbackUpdate) {
          review[updateVoteKey]--;
          review.IsVotedByUser = false;
        } else {
          review[updateVoteKey]++;
          review.IsVotedByUser = true;
        }
      },
    );

    /* istanbul ignore next */
    eventBus.on('FilterstarLabel', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1; // pagination index
      this.currentPaginationPage = 0; // carousel index
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = true;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('rfp-global-page-change', (value) => {
      this.currentPaginationPage = value;
    });
    /* istanbul ignore next */
    eventBus.on('oneTwoThree', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = true;
      this.stars.twoStar = true;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('filterOne', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = true;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = true;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this.oneStarText);
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('filterTwo', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = true;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = true;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this.twoStarText);
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('filterThree', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = true;
      this.stars.fourStar = false;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = true;
      this.rfpFilterFour = false;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this.threeStarText);
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('filterFour', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = true;
      this.stars.fiveStar = false;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = true;
      this.rfpFilterFive = false;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this.fourStarText);
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('filterFive', () => {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.stars.oneStar = false;
      this.stars.twoStar = false;
      this.stars.threeStar = false;
      this.stars.fourStar = false;
      this.stars.fiveStar = true;
      this.rfpFilterOne = false;
      this.rfpFilterTwo = false;
      this.rfpFilterThree = false;
      this.rfpFilterFour = false;
      this.rfpFilterFive = true;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.$refs.carousel?.resetCurrentPage();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this.fiveStarText);
      this.fetchReviews();
    });
    /* istanbul ignore next */
    eventBus.on('dataGetFromDB', (val) => {
      const calculation = this.currentPageNo + 1;
      const calculateCondition = val + 2;
      if (calculateCondition > this.items.length) {
        this.currentPageNo = calculation;
        this.fetchReviews(true);
      }
    });
  },
  methods: {
    async initDefaultReviews() {
      try {
        if (!this.defaultReviewsJson) {
          throw new Error('defaultReviewsJson is empty');
        }
        this.items = JSON.parse(this.defaultReviewsJson);
      } catch (error) {
        console.error('Error parsing defaultReviewsJson prop:', error);
        console.log('Fallback fetching reviews');
        await this.fetchReviews();
      } finally {
        this.isDefaultSlotRendered = false;
      }
    },
    setReadReviewTaggingEventWatcher() {
      const unwatch = this.$watch(
        () => this.itemsWithNickname.length > 0 && !this.isDefaultSlotRendered,
        async (isReviewItemRenderedClientSide) => {
          if (!isReviewItemRenderedClientSide) return;

          await this.$nextTick();
          const commentElement = document.querySelector('.rr-user-review-comment');
          if (!commentElement) return;

          this.onElementVisible(commentElement, () => {
            eventBus.emit('readReviewTags');
          });

          this.$nextTick(() => unwatch());
        },
        { immediate: true },
      );
    },
    openModal(position, data) {
      this.carouselConfig = {
        ...this.carouselConfig,
        mainPosition: position,
        modalImages: data,
        showModal: true,
      };
    },
    closeModal() {
      this.carouselConfig.showModal = false;
    },
    onElementVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
    },
    async fetchReviews(concatenateResults = false) {
      const currentPage = this.currentPageNo;

      const params = new URLSearchParams({
        languageCode: this.languageCode,
        productId: this.productId,
        page: currentPage,
        loadFromMultipleLanguages: this.loadFromMultipleLanguages,
        pageSize: this.reviewPaginationCount,
        sortData: this.selectedSortValue,
      });

      Object.values(this.stars).forEach((s, index) => {
        if (s) params.append('filterData', index + 1);
      });

      this.loadingItems = true;

      const currentResetResultsApiRequestCount = this.resetResultsApiRequestCount;
      const url = `${this.baseUrlsFetchReviewDetails}?${params}`;

      return fetch(url, {
        headers: { Pragma: 'no-cache' },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (currentResetResultsApiRequestCount !== this.resetResultsApiRequestCount) {
            return;
          }

          const { ProductReviews, TotalNoOfApprovedReviews } = data;
          this.totalNoOfApprovedReviews = TotalNoOfApprovedReviews;

          // in carousel mode, append new pagination items to the list, unless filtering
          // the concatenate flag will only ever be set in the `dataGetFromDB` handler
          if (this.ratingsListOption === CAROUSEL_VIEW || this.ratingsListOption === LOAD_MORE) {
            if (concatenateResults) {
              this.items.push(...ProductReviews);
            } else {
              this.items = ProductReviews;
            }
            return;
          }

          if (currentPage === this.currentPageNo) {
            this.items = ProductReviews;
          }

          // reassign to support vue2 reactivity
          this.itemsByPage = {
            ...this.itemsByPage,
            ['page' + currentPage]: ProductReviews,
          };
        })
        .finally(() => {
          if (currentResetResultsApiRequestCount === this.resetResultsApiRequestCount) {
            this.loadingItems = false;
          }
        });
    },
    async updatePage(pageNum) {
      this.currentPageNo = pageNum;
      const chachedItems = this.itemsByPage['page' + pageNum];

      if (chachedItems) {
        this.items = chachedItems;
      } else {
        this.maxPageLength = pageNum;
        await this.fetchReviews();
      }

      this.scrollToFirstItem();
    },
    scrollToFirstItem() {
      const elem = document.querySelector('.js-rfp-rr-ratings-list-item');
      if (!elem) return;

      const offset = parseInt(
        getComputedStyle(elem).getPropertyValue('--refapp-brand-sticky-header-height'),
        10,
      );
      this.$scrollTo(elem, 500, { offset: -offset || 0 });
      elem.focus({ preventScroll: true });
    },
    loadMoreReviews() {
      this.currentPageNo++;
      this.fetchReviews(true);
    },
    toggleSortDropdown() {
      this.isSortDropdownOpen = !this.isSortDropdownOpen;
    },
    sortReviews(sortValue) {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.selectedSortValue = sortValue;
      this.isSortDropdownOpen = false;
      eventBus.emit('sortReviewsTags', this.selectedSortLabel);

      this.currentPageNo = 1;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      this.fetchReviews();
    },

    filterByStars(rank) {
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }

      const filterIdentifier = `rfpFilter${rank[0].toUpperCase()}${rank.slice(1)}`;
      const starIdentifier = `${rank}Star`;

      if (!this.stars[`${rank}Star`]) {
        eventBus.emit(FILTER_ACTION_TRIGGERED_EVENT, this[`${rank}StarText`]);
      }

      this.stars[starIdentifier] = !this.stars[starIdentifier];
      this[filterIdentifier] = !this[filterIdentifier];
      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      this.$refs.paginationLinks?.resetPaginationLink();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      this.fetchReviews();
    },

    clearAllStars() {
      const filterKeys = [
        'rfpFilterOne',
        'rfpFilterTwo',
        'rfpFilterThree',
        'rfpFilterFour',
        'rfpFilterFive',
      ];
      Object.keys(this.stars).forEach((key) => (this.stars[key] = false));
      filterKeys.forEach((key) => (this[key] = false));

      this.currentPageNo = 1;
      this.currentPaginationPage = 0;
      if (this.ratingsListOption === this.LOAD_MORE) {
        this.items = [];
      }
      this.$refs.paginationLinks?.resetPaginationLink();
      this.resetResultsApiRequestCount++;
      this.itemsByPage = {};
      this.fetchReviews();
    },
    mouseOver() {
      this.active = !this.active;
    },
    handleSortBlur(e) {
      if (
        e.relatedTarget !== this.$refs.sortLabel &&
        !this.$refs.sortOptionsList?.contains(e.relatedTarget)
      ) {
        this.isSortDropdownOpen = false;
      }
    },
    closeSortOptions() {
      this.isSortDropdownOpen = false;
    },
    reportReview(review) {
      if (review.IsReported === this.reportedText) return;

      eventBus.emit('rfpSetReportedStatus', { reviewId: review.RRID, isReported: true });

      const params = new URLSearchParams({ rrID: review.RRID });
      const url = `${this.reportReviewApi}?${params}`;
      fetch(url, { method: 'PATCH', headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (!['Success', 'AlreadyReported'].includes(data.Status)) {
            throw new Error(data.Message);
          }
        })
        .catch(() => {
          eventBus.emit('rfpSetReportedStatus', { reviewId: review.RRID, isReported: false });
        });
    },
    async voteReview(reviewId, isHelpful) {
      const review = this.items.find((item) => item.RRID === reviewId);

      if (!review || review.IsVotedByUser) {
        return;
      }

      const reviewUpdateAPI = this[isHelpful ? 'updateHelpfulReviewApi' : 'updateNotHelpfulReview'];
      const taggingEventName = isHelpful ? 'LikeReviewTags' : 'unLikeReviewTags';

      // optimistic update
      eventBus.emit('rfpUpdateReviewVote', {
        reviewId,
        isHelpful,
      });

      eventBus.emit(taggingEventName);

      const params = new URLSearchParams({ rrID: reviewId });
      const url = `${reviewUpdateAPI}?${params}`;
      fetch(url, { method: 'PATCH', headers: { Pragma: 'no-cache' } })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP error ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data.Status !== 'Success') {
            throw new Error(data.Message);
          }
        })
        .catch((e) => {
          console.error(`error/rfp-ratings-list#updateReview: Operation failed`, e);
          eventBus.emit('rfpUpdateReviewVote', {
            reviewId,
            isHelpful,
            rollbackUpdate: true,
          });
        });
    },
  },
};
</script>
